import { FormTags, FormTextArea } from 'components/shared/Forms/ReduxForm'
import { I18n } from 'lib/i18n'
import PropTypes from 'prop-types'
import React from 'react'
import Markdown from 'react-markdown'
import { Field, formValues } from 'redux-form'
import { Grid, Header, Icon, Label, Segment } from 'semantic-ui-react'

class ProductKeywordsDescription extends React.Component {
  static propTypes = {
    suggestions: PropTypes.object.isRequired,
  }

  render() {
    const { suggestions, description_de, description_fr } = this.props

    return (
      <Grid stackable>
        <Grid.Row>
          <Grid.Column width={12}>
            <Header dividing content={I18n.t('navigation.languages.de')} />
            <Field
              component={FormTags}
              suggestions={suggestions.de}
              name="keywords_de"
              allowNew
              autofocus={false}
            />
          </Grid.Column>
          <Grid.Column width={12}>
            <Field
              component={FormTextArea}
              placeholder={I18n.t('admin.productDescription.placeholder_de')}
              name="description_de"
            />
            <p>
              {I18n.t('admin.general.supports_markdown')}
              <a
                href="http://commonmark.org/"
                target="_blank"
                rel="noopener noreferrer">
                <Icon name="info circle" color="blue" />
              </a>
            </p>

            {description_de && (
              <Segment raised>
                <Label attached="top right">Vorschau</Label>
                <Markdown source={description_de || ''} skipHtml />
              </Segment>
            )}
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={12}>
            <Header dividing content={I18n.t('navigation.languages.fr')} />
            <Field
              component={FormTags}
              suggestions={suggestions.fr}
              name="keywords_fr"
              allowNew
              autofocus={false}
            />
          </Grid.Column>
          <Grid.Column width={12}>
            <Field
              component={FormTextArea}
              placeholder={I18n.t('admin.productDescription.placeholder_fr')}
              name="description_fr"
            />
            {description_fr && (
              <Segment raised>
                <Label attached="top right">Vorschau</Label>
                <Markdown source={description_fr || ''} skipHtml />
              </Segment>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

ProductKeywordsDescription = formValues('description_de', 'description_fr')(
  ProductKeywordsDescription
)
export default ProductKeywordsDescription



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductKeywordsDescription.jsx